import {
   DATALINK_CONTENT,
   CONNECTOR_CACHE_PUT,
   CONNECTOR_CACHE_PULL,
   PAGE_CONTENT
} from '../constants';
import moment from 'moment';
const INIT_STATE = {
  networkDashboards:[],
  userProfilePageContent:{},
  connectors:{},
  Locations:[]
}; 

export default (state = INIT_STATE, action) => {
  var stateRefresh = (action.payload) ? action.payload : action;
  switch (action.type) { 
    case CONNECTOR_CACHE_PUT:
      
      var obj = {...state};
      if (action.payload.cacheKey != ""){
      var payload = action.payload;
          obj.connectors[payload.cacheKey] = payload.data;
      }
          return {
            ...state,
            ...obj
          }
      break;
      case CONNECTOR_CACHE_PULL:
       var obj = {};
       var payload = action.payload;
          obj.dataLinkPageItems = payload.data;
          return {
            ...state,
            ...obj
          }
      break;
    case DATALINK_CONTENT:
      var uicontent = stateRefresh.payload && stateRefresh.payload.formId ? stateRefresh.payload.formId : false;
      var obj = {};
      if (uicontent){
        
        obj[uicontent] = stateRefresh.data;
      }else{
          obj = {data:stateRefresh.data};
      }
      return { 
             ...state,
             ...obj
      };
    break;
    case PAGE_CONTENT:
      var uicontent = stateRefresh.payload && stateRefresh.payload.formId ? stateRefresh.payload.formId : false;
      var obj = {};
      if (uicontent){
        
        obj[uicontent] = stateRefresh.data ? stateRefresh.data : stateRefresh.response.pageContent ? stateRefresh.response.pageContent : {};
      }else{
          obj = {data:stateRefresh.data};
      }
      return { 
             ...state,
             ...obj
      };
    break;
    default:
      return { 
      ...state
};
    break;
  }
};
